import React, { forwardRef, useState, useMemo, useCallback } from 'react'
import { FieldTypes } from 'utils/formUtils';
import { urlRegexValidator } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import SonarqubeMappingFormV2 from './SonarqubeMappingFormV2';

const AUTH_TYPES_CONFIG = {
    basicAuth: 'basicAuth',
    tokenAuth: 'tokenAuth', 
}

function SonarqubeCredentialsForm(props, ref) {
    const [authenticationType, setAuthType] = useState(AUTH_TYPES_CONFIG.basicAuth);

    const handleRadioChange = useCallback((e) => {
        setAuthType(e.target.value);
    },[]);

    const basicAuthFields = useMemo(()=>([{
        name: "userName",
        label: "User Name",
        props: {
            autoFocus: true
        },
        required: true
    }, {
        name: "password",
        label: "Password",
        type: FieldTypes.PASSWORD,
        required: true
    }]),[]);
    
    const tokenAuthFields = useMemo(() => ([{
        name: "token",
        label: "Token",
        type: FieldTypes.PASSWORD,
        required: true
    }]),[]);

    const fields = useMemo(() => {
        const authFieled = authenticationType === AUTH_TYPES_CONFIG.tokenAuth ? tokenAuthFields : basicAuthFields;
        return (
            [{
                name: "apiEndpoint",
                label: "API Endpoint",
                required: true,
                rules:[urlRegexValidator],
            },{
                name: "authenticationType",
                type: FieldTypes.RADIO,
                options: [
                    {
                        label: 'Basic Auth',
                        value: AUTH_TYPES_CONFIG.basicAuth
                    },
                    {
                        label: 'Token Auth',
                        value: AUTH_TYPES_CONFIG.tokenAuth
                    }
                ],
                props: {
                    onChange: handleRadioChange,
                    defaultValue: authenticationType,
                }
            },
            ...authFieled]
        );
    },[authenticationType, tokenAuthFields, basicAuthFields, handleRadioChange])

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={SonarqubeMappingFormV2}
        />
    )
}

export default forwardRef(SonarqubeCredentialsForm);